(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj === "undefined" ? "undefined" : _typeof(obj); }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj); }); } return _typeof(obj); }

jQuery(document).ready(function ($) {
  Modernizr.webp;
  $(window).scroll(function () {
    var scrolltop = $(window).scrollTop();
    var scrollwindow = scrolltop + $(window).height();

    if ($(".csa-module.backdrop").length) {
      var sectionoffset = $(".csa-module.backdrop").offset().top;

      if (scrollwindow > sectionoffset) {
        var backgroundscroll = scrollwindow - sectionoffset;
        $(".csa-module.backdrop").css("background-position", "50% " + -(scrolltop / 9) + "px");
      }
    }
  });
  $('.mi-bar').waypoint(function (direction) {
    var elinfo = this.element.className.match(/apply-\d+/);

    if (elinfo) {
      var pn = 'percentage-' + elinfo[0].split('-')[1];

      if (this.element.className.indexOf(pn) > -1) {// Do nothing
      } else {
        this.element.classList.add(pn);
      }
    }
  }, {
    offset: '95%'
  });
  $(".csa-location-item").on('click', function () {
    var lid = $(this).prop('id').slice(-1);
    simplemaps_usmap_mapdata.locations[lid].description = 'New';
  });
  $('.csa-item.accordion-item').on('click', function () {
    var accitem = $(this);
    var chev = $(this).find('.aic-dropdown i');

    if ($(accitem).hasClass('open') === true) {
      $('.csa-item.accordion-item').removeClass('open');
      $('.csa-item.accordion-item .aic-dropdown i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    } else {
      $('.csa-item.accordion-item').removeClass('open');
      $('.csa-item.accordion-item .aic-dropdown i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      $(accitem).addClass('open');
      $(chev).removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
  });
});

(function ($) {
  var opt = {};
  var methods = {
    init: function init(options) {
      options = $.extend({}, $.fn.wgResources.defaults, options);
      var postdata = create_object(options.action, options.orderby, options.order, options.page, options.ppp, options.lib, options.media, options.prod, options.com, options.search);
      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: postdata,
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(JSON.stringify(errorThrown));
        },
        success: function success(data, textStatus, jqXHR) {
          console.log(JSON.stringify(data));
        }
      });
    },
    fetch: function fetch(options) {
      console.log(JSON.stringify(options, null, 4));
      options = $.extend({}, $.fn.wgResources.defaults, options); //console.log( JSON.stringify( typeof options.page, null, 4 ) );

      var postdata = create_object(options.action, options.orderby, options.order, options.page, options.ppp, options.lib, options.media, options.prod, options.com, options.search); //console.log( JSON.stringify( postdata, null, 4 ) );

      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: postdata,
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(JSON.stringify(errorThrown, null, 4));
        },
        success: function success(data, textStatus, jqXHR) {
          //console.log( JSON.stringify( data.header, null, 4 ) );
          render_blocks(data, options.target);
        }
      });
    },
    tags: function tags(options) {
      options = $.extend({}, $.fn.wgResources.defaults, options);
      var postdata = create_object(options.action, options.orderby, options.order, parseInt(options.page), options.ppp, options.lib, options.media, options.prod, options.com, options.search);
      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: postdata,
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(JSON.stringify(errorThrown, null, 4));
        },
        success: function success(data, textStatus, jqXHR) {
          render_tags(data);
        }
      });
    },
    test: function test(options) {
      console.log(JSON.stringify(options, null, 4));
    }
  };

  function render_blocks(data, target) {
    var theheader = data.header; //console.log( JSON.stringify( theheader[ "supplied_arguements" ].lib, null, 4 ) );

    var thedata = data.content;
    $("#" + target).empty();
    var wrapper_row = add_element('[{"type":"div","atts":[{"id":"cswg_resources_wrapper","class":"cswg_resources_wrapper" }],"content":"" }]');

    if (thedata.length > 0) {
      var paging_bar_top = add_element('[{"type":"div","atts":[{"id":"cswg_resources_paging_top","class":"cswg_resources_paging_top paging_bar" }],"content":"" }]');
      var paging_bar_tprev = add_element('[{"type":"div","atts":[{"id":"cswg_resources_paging_prev_top","class":"cswg_resources_paging_prev_top paging_item paging_prev" }],"content":"<< Prev" }]');
      /*if( parseInt( theheader[ "current_page" ] )-1 < 1 ){
        $( paging_bar_tprev ).addClass( "paging_inactive" );
      } else {
        $( paging_bar_tprev ).removeClass( "paging_inactive" );*/

      $(paging_bar_tprev).on("click", function () {
        //console.log( JSON.stringify( "Clicked", null, 4 ) );
        var thepage = parseInt(theheader["current_page"]) - 1;
        var args = [{
          action: "cs_wg_fetch_tags_proxy",
          orderby: "name",
          order: "ASC",
          page: thepage,
          ppp: theheader["posts_per_page"],
          lib: theheader["supplied_arguements"].lib,
          media: theheader["supplied_arguements"].media,
          prod: theheader["supplied_arguements"].prod,
          com: theheader["supplied_arguements"].com,
          search: theheader["supplied_arguements"].search,
          target: target
        }];
        $("body").wgResources("fetch", args);
      }); //}

      var paging_bar_tnext = add_element('[{"type":"div","atts":[{"id":"cswg_resources_paging_next_top","class":"cswg_resources_paging_next_top paging_item paging_next" }],"content":"Next >>" }]');
      /*if( parseInt( theheader[ "current_page" ] )*parseInt( theheader[ "posts_per_page" ] ) >= parseInt( theheader[ "total_records" ] ) ){
        $( paging_bar_tnext ).addClass( "paging_inactive" );
      } else {
        $( paging_bar_tnext ).removeClass( "paging_inactive" );*/

      $(paging_bar_tnext).on("click", function () {
        var thepage = parseInt(theheader["current_page"]) + 1; //console.log( JSON.stringify( typeof thepage, null, 4 ) );

        var args = [{
          action: "cs_wg_fetch_tags_proxy",
          orderby: "name",
          order: "ASC",
          page: thepage.toString(),
          ppp: theheader["posts_per_page"],
          lib: theheader["supplied_arguements"].lib,
          media: theheader["supplied_arguements"].media,
          prod: theheader["supplied_arguements"].prod,
          com: theheader["supplied_arguements"].com,
          search: theheader["supplied_arguements"].search,
          target: target
        }]; //console.log( JSON.stringify( args, null, 4 ) );

        $("body").wgResources("fetch", args);
      }); //}

      $(paging_bar_top).append(paging_bar_tprev, paging_bar_tnext);
      $.each(thedata, function (index) {
        var block_content = add_element('[{"type":"div","atts":[{"id":"cswg_resources_block_content-' + thedata[index].ID + '","class":"csad_srchable_content_block cswg_resources_block_content" }],"content":"" }]');
        var block_title = add_element('[{"type":"h4","atts":[{"id":"cswg_resources_block_title-' + thedata[index].ID + '","class":"cswg_resources_block_title" }],"content":"' + thedata[index].post_title + '" }]');
        var block_linkwrap = add_element('[{"type":"a","atts":[{"href":"' + thedata[index].package["download_url"] + '","id":"cswg_resources_block_link_wrap-' + thedata[index].ID + '","class":"cswg_resources_block_link_wrap" }],"content":"" }]');
        var block_image = add_element('[{"type":"div","atts":[{"id":"cswg_resources_block_image-' + thedata[index].ID + '","class":"cswg_resources_block_image" }],"content":"" }]');
        $(block_image).html(thedata[index].package["icon"]);
        var block_dlicon = add_element('[{"type":"span","atts":[{"id":"cswg_resources_block_dlicon-' + thedata[index].ID + '","class":"eltd_icon_font_awesome fa fa-download button_icon cswg_resources_block_dlicon" }],"content":"" }]');
        var block_dltext = add_element('[{"type":"span","atts":[{"id":"cswg_resources_block_dltext-' + thedata[index].ID + '","class":"cswg_resources_block_dltext" }],"content":"' + thedata[index].package["link_label"] + '" }]');
        var block_dlbutton = add_element('[{"type":"div","atts":[{"id":"cswg_resources_block_dlbutton-' + thedata[index].ID + '","class":"qbutton  qbutton_with_icon icon_right cswg_resources_block_dlbutton" }],"content":"" }]');
        $(block_dlbutton).append(block_dlicon, block_dltext);
        $(block_linkwrap).append(block_title, block_image, block_dlbutton);
        $(block_content).append(block_linkwrap);
        $(wrapper_row).append(block_content);
      });
      var paging_bar_bottom = add_element('[{"type":"div","atts":[{"id":"cswg_resources_paging_bottom","class":"cswg_resources_paging_bottom paging_bar" }],"content":"" }]');
      var paging_bar_bprev = add_element('[{"type":"div","atts":[{"id":"cswg_resources_paging_prev_bottom","class":"cswg_resources_paging_prev_bottom paging_item paging_prev" }],"content":"<< Prev" }]');

      if (parseInt(theheader["current_page"]) - 1 < 1) {
        $(paging_bar_bprev).addClass("paging_inactive");
      } else {
        $(paging_bar_bprev).removeClass("paging_inactive");
      }

      var paging_bar_bnext = add_element('[{"type":"div","atts":[{"id":"cswg_resources_paging_next_bottom","class":"cswg_resources_paging_next_bottom paging_item paging_next" }],"content":"Next >>" }]');

      if (parseInt(theheader["current_page"]) * parseInt(theheader["posts_per_page"]) >= parseInt(theheader["total_records"])) {
        $(paging_bar_bnext).addClass("paging_inactive");
      } else {
        $(paging_bar_bnext).removeClass("paging_inactive");
      }

      $(paging_bar_bottom).append(paging_bar_bprev, paging_bar_bnext);
      $("#" + target).append(paging_bar_top, wrapper_row, paging_bar_bottom);
    } else {
      var empty_msg_outter = add_element('[{"type":"div","atts":[{"id":"cswg_resources_empty_outter","class":"cswg_resources_empty_outter" }],"content":"" }]');
      var empty_msg_inner = add_element('[{"type":"div","atts":[{"id":"cswg_resources_empty_inner","class":"cswg_resources_empty_inner" }],"content":"No files were found that matched the given criteria." }]');
      $(empty_msg_outter).append(empty_msg_inner);
      $("#" + target).append(empty_msg_outter);
    }
  }

  function render_tags(data) {
    var thedata = data.content;
    $.each(thedata, function (index) {
      var tagdata = thedata[index].data;
      var n = thedata[index].target.lastIndexOf('_');
      var fname = thedata[index].target.substring(n + 1);
      var first_option = add_element('[{"type":"option","atts":[{"value":"" }],"content":"Select ' + fname.charAt(0).toUpperCase() + fname.slice(1) + '" }]');
      $("#" + thedata[index].target).append(first_option);
      $.each(tagdata, function (ind) {
        var select_option = add_element('[{"type":"option","atts":[{"value":"' + tagdata[ind][0] + '" }],"content":"' + tagdata[ind][1] + '" }]');
        $("#" + thedata[index].target).append(select_option);
      });
    });
  }

  function create_object(action, orderby, order, page, ppp, lib, media, prod, com, search) {
    var postdata = {
      "action": action,
      "orderby": orderby,
      "order": order,
      "page": page,
      "ppp": ppp,
      "lib": lib,
      "media": media,
      "prod": prod,
      "com": com,
      "search": search
    };
    return postdata;
  }

  function add_element(data) {
    var thedata = JSON.parse(data);
    var theelement;
    $.each(thedata, function (index) {
      theelement = document.createElement(thedata[index].type);
      var theatts = thedata[index].atts;
      $.each(theatts, function (i) {
        var thekeys = Object.keys(theatts[i]);
        $.each(thekeys, function (mykey) {
          var k = thekeys[mykey];
          var v = theatts[i][thekeys[mykey]];

          if (k === "class") {
            $(theelement).addClass(v);
          } else {
            $(theelement).attr(k, v);
          }
        });
      });
      $(theelement).html(thedata[index].content);
    });
    return theelement;
  }

  $.fn.wgResources = function (method, options) {
    if (methods[method]) {
      // console.log( JSON.stringify( options, null, 4 ) );
      methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if ((typeof method === "undefined" ? "undefined" : _typeof(method)) === 'object' || !method) {
      return methods.init.apply(this, options);
    } else {
      console.log('Method ' + method + ' does not exist on wgResources');
    }
  };

  $.fn.wgResources.defaults = {
    action: "cs_wg_fetch_attachments_proxy",
    orderby: "post_title",
    order: "ASC",
    ppp: 20,
    lib: "",
    media: "",
    prod: "",
    com: ""
  };
})(jQuery);

},{}],2:[function(require,module,exports){
"use strict";

require("./base.js");

/*import 'custom/filters.js';*/

/*
* Copyright (c) 2019 Matthew Swetnam
*/
jQuery(document).ready(function ($) {
  console.log("Wrench Group");
});

},{"./base.js":1}]},{},[2]);
